import type { Environment } from '@infinex/chain-config';
import { initializeChainConfigEnv } from '@infinex/chain-config';

import { envVars } from './config';

export const isDev = (): boolean => envVars.INFINEX_ENVIRONMENT === 'dev';

export const isStaging = (): boolean =>
  envVars.INFINEX_ENVIRONMENT === 'staging';

export const isProd = (): boolean => envVars.INFINEX_ENVIRONMENT === 'prod';

export const initEnv = () => {
  initializeChainConfigEnv(envVars.INFINEX_ENVIRONMENT as Environment);
};
